import {z} from 'zod';
import {ObjectIdSchema} from '../../zod';
import {ApiDefinition, WithIdSchema} from '../definitions';
import {CampaignChatSchema, CampaignSchema} from '../../chatabm';

const GetCampaignChatsResponseSchema = CampaignChatSchema.pick({
  name: true,
  createdAt: true,
}).extend(WithIdSchema);
export type GetCampaignChatsResponse = z.infer<
  typeof GetCampaignChatsResponseSchema
>;

export const GetCampaignChats = {
  path: 'chatabm/getCampaignChats',
  method: 'get',
  options: {access: 'admin'},
  requestDataSchema: z.object({}),
  responseDataSchema: GetCampaignChatsResponseSchema.array(),
} satisfies ApiDefinition;

export const GetCampaignChat = {
  path: 'chatabm/getCampaignChat',
  method: 'get',
  options: {access: 'admin'},
  requestDataSchema: z.object({
    campaignChatId: ObjectIdSchema,
  }),
  responseDataSchema: CampaignChatSchema.extend(WithIdSchema).nullable(),
} satisfies ApiDefinition;

export const GenerateCampaigns = {
  path: 'chatabm/generateCampaigns',
  method: 'post',
  options: {access: 'admin'},
  requestDataSchema: z.object({
    campaignName: z.string(),
    domain: z.string(),
    testListId: ObjectIdSchema,
  }),
  responseDataSchema: z.object({
    taskId: ObjectIdSchema,
  }),
} satisfies ApiDefinition;

export const UpdateCampaigns = {
  path: 'chatabm/updateCampaigns',
  method: 'post',
  options: {access: 'admin'},
  requestDataSchema: z.object({
    campaignChatId: ObjectIdSchema,
    previousResponseId: z.string(),
  }),
  responseDataSchema: z.object({
    campaigns: CampaignSchema.array(),
    responseId: z.string(),
  }),
} satisfies ApiDefinition;
